import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import {DISPATCH_ID} from "../libs/utils/Const";
import {SearchItemsActions} from './index';


class NavbarSearchIcon extends Component {

    componentDidMount() {
        $(".ico-nav-shearch").click(function(){
            $(".form-buscar").toggle();
            $(".input-search-responsive").focus();
        });
    }

    search = async () => {
        const {itemsReducer} = this.props;
        await itemsReducer.searchByKey();
        $(".input-search-responsive").blur();
        $(".form-buscar").toggle()
    };

    render() {
        const {itemsReducer, setSearch, icon, iconColor} = this.props;
        return (
            
                <span>
                    <i className={icon + " ico-nav-shearch d-md-none"} style={{color: iconColor, padding: 0}}/>
                    <span className="form-buscar" style={{display:'none'}}>
                    <div className='input-group pl-2 pr-2' style={{zIndex: "2021", position: "fixed", left: "0vw", top :56}} >
                        <input 
                            type="text"
                            style={{height:"40px"}}
                            className="form-control text-center "
                            placeholder="Buscar"
                            value={itemsReducer.search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyDown={event => event.keyCode === 13 && this.search() }
                            // onBlur={ () => $(".form-buscar").toggle()}
                        />
                        <div className="input-group-append">
                            <button className="btn  " type="button" style={{borderColor: "#000000 !important", borderLeft: "transparent", color: "#ced4da", background:"rgb(60 60 59)"}} onClick={()=>this.search()}>                        
                                <i
                                    // className={icon}
                                    className="fa fa-search"
                                    style={{cursor: 'pointer', color: "white",  background:"rgb(60 60 59) !important"}}
                                    aria-hidden="true"
                                />
                            </button>
                        </div>
                    </div>
                    </span>
                </span>
                

        );
    };

}


const mapStateToProps = store => {
    return {
        configReducer: store.ConfigReducer,
        itemsReducer: store.ItemsReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_SEARCH, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavbarSearchIcon)

